import * as React from "react";
import { Box, useLocalVariant } from "@draftkings/arena-web";
export const Loading = React.memo(function Loading(props) {
    const { purchaseId } = props;
    const variant = useLocalVariant("layout", {
        root: {
            position: "absolute",
            bottom: 0,
            height: "8px",
            backgroundColor: "$green400",
            marginLeft: "0%",
            borderRadius: "4px",
            transition: "width 0.4s ease-in 0.2s",
            zIndex: 2,
            width: "43%",
            animationName: "bounce",
            animationIterationCount: "infinite",
            animationDirection: "alternate",
            animationDuration: "1s",
            animationDelay: "0.55s",
        }
    });
    return React.createElement(Box, { position: "relative", height: "8px", marginBottom: "16px", borderRadius: "16px", backgroundColor: "rgba(77, 77, 77, 0.6);" },
        React.createElement(Box, { testId: `cashout-loader-${purchaseId}`, variant: `layout.${variant}` }));
});
//# sourceMappingURL=Loading.js.map